import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProofBar } from '../components/SocialProofBar';
const ProblemSection = lazy(() => import('../components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('../components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const WhatYouGet = lazy(() => import('../components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const UrgencySection = lazy(() => import('../components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTA = lazy(() => import('../components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-black" data-id="element-432">
      <div data-id="element-433">
        <HeroSection data-id="element-434" />
        <SocialProofBar data-id="element-435" />

        <Suspense fallback={null} data-id="element-436">
          <ProblemSection data-id="element-437" />
          <SolutionSection data-id="element-438" />
          <WhatYouGet data-id="element-439" />
          <BonusSection data-id="element-440" />
          <UrgencySection data-id="element-441" />
          <PricingSection data-id="element-442" />
          <TestimonialsSection data-id="element-443" />
          <GuaranteeSection data-id="element-444" />
          <FAQSection data-id="element-445" />
          <FinalCTA data-id="element-446" />
          <Footer data-id="element-447" />
          <SocialProofPopup data-id="element-448" />
        </Suspense>
      </div>
    </main>;
}